import createReducer from '../../helpers/CreateReducer';
import {
  ApiConstants,
  TransactionsHistoryConstants
} from '../../constants/actions';
import { TransactionsHistorySorting } from '../../constants/transactionsHistorySorting';

export interface Transaction {
  id: string;
}

export interface QueryParameters {
  page: number;
  rowsPerPage: number;
  sortingBy: string;
  descending: boolean;
}

export interface TransactionsHistoryState {
  transactions: Transaction[];
  totalPages: number;
  queryParameters: QueryParameters;
  isError?: boolean;
}

export const getInitialState = (): TransactionsHistoryState => ({
  transactions: [],
  totalPages: 1,
  queryParameters: {
    page: 1,
    rowsPerPage: 20,
    sortingBy: TransactionsHistorySorting.ByDate,
    descending: true
  }
});

interface SetQueryParametersAction {
  queryParameters: QueryParameters;
}

interface LoadTransactionsSuccessAction {
  payload: {
    transactionsHistoryResponse: {
      transactions: Transaction[];
      totalPages: number;
    };
  };
}

export default createReducer(getInitialState, {
  [TransactionsHistoryConstants.SET_TRANSACTIONS_HISTORY_QUERY_PARAMETERS]: (
    state: TransactionsHistoryState,
    { queryParameters }: SetQueryParametersAction
  ) => {
    return {
      ...state,
      queryParameters
    };
  },

  [`${ApiConstants.LOAD_TRANSACTIONS_HISTORY}_SUCCESS`]: (
    state: TransactionsHistoryState,
    { payload }: LoadTransactionsSuccessAction
  ) => ({
    ...state,
    transactions: payload.transactionsHistoryResponse.transactions || [],
    totalPages: payload.transactionsHistoryResponse.totalPages
  }),

  [`${ApiConstants.LOAD_TRANSACTIONS_HISTORY}_FAILURE`]: (
    state: TransactionsHistoryState
  ) => ({
    ...state,
    transactions: [],
    isError: true
  })
});
